import { FC } from "react";
import { DropsButton, Text } from "shared/components/Spor";
import {
  DropdownDownFill18Icon,
  DropdownUpFill18Icon,
} from "@vygruppen/spor-icon-react";
import styled from "styled-components";

export const TRAIN_LIMIT = 10;

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
`;

const Third = styled.div<{ $align: string }>`
  flex-basis: calc(100% / 3);

  display: flex;
  justify-content: ${({ $align }) => $align};
`;

type ActionableTrainSectionFooterProps = {
  toggleAll: () => void;
  showAll: boolean;
  currentLength: number;
  totalLength: number;
};

export const ActionableTrainSectionFooter: FC<
  ActionableTrainSectionFooterProps
> = ({ toggleAll, showAll, currentLength, totalLength }) => (
  <Wrapper>
    <Third $align="flex-start">&nbsp;</Third>

    <Third $align="center">
      {totalLength > TRAIN_LIMIT && (
        <DropsButton
          variant="ghost"
          size="xs"
          fontWeight={400}
          rightIcon={
            showAll ? <DropdownUpFill18Icon /> : <DropdownDownFill18Icon />
          }
          onClick={toggleAll}
        >
          Vis {showAll ? "færre" : "alle"} tog ({totalLength})
        </DropsButton>
      )}
    </Third>

    <Third $align="flex-end">
      <Text variant="sm" color="textSecondary">
        Viser {currentLength} av {totalLength}
      </Text>
    </Third>
  </Wrapper>
);
